import { Control } from "react-hook-form";

import { labelEmail } from "_constants";
import { EmailInput } from "components/shared";

export const EmailContainer = ({
  control,
}: {
  control: Control<
    {
      name: string;
      lastName: string;
      email: string;
    },
    any
  >;
}) => {
  return (
    <div className="flex-container column gap-8">
      <span className="text-base-bold">{labelEmail.toUpperCase()}</span>
      <EmailInput control={control} disabled={true} />
    </div>
  );
};
